<template>
  <div class="page-error-container">
    <div class="page-error">
      <div v-if="!error || error.includes('403')">
        <div class="notfound-404">
          <h1>4<span>0</span>4</h1>
        </div>
        <h2>The page you requested could not found</h2>
      </div>
      <div v-else>
        <h2>{{ error }}</h2>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ErrorComponent',
  data() {
    return {
      error: this.$route.query.error
    }
  }
}
</script>
<style lang="scss" scoped>
.page-error-container {
  display: flex;
  align-items: center;
  justify-content: center;

  .page-error {
    max-width: 767px;
    width: 100%;
    line-height: 1.4;
    padding: 50px 40px;
    text-align: center;
    background: #fff;
    .notfound-404 {
      position: relative;
      height: 180px;
      h1 > span {
        color: #00b7ff;
      }
      h1 {
        font-family: 'Roboto', sans-serif;
        position: absolute;
        left: 50%;
        top: 50%;
        -webkit-transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        font-size: 165px;
        font-weight: 700;
        margin: 0px;
        color: #262626;
        text-transform: uppercase;
      }
    }
    h2 {
      font-family: 'Roboto', sans-serif;
      font-size: 22px;
      font-weight: 400;
      text-transform: uppercase;
      color: #151515;
      margin-top: 0px;
      margin-bottom: 25px;
    }
  }
  a {
    font-family: 'Titillium Web', sans-serif;
    display: inline-block;
    text-transform: uppercase;
    color: #fff;
    text-decoration: none;
    border: none;
    background: #5c91fe;
    padding: 10px 40px;
    font-size: 14px;
    font-weight: 700;
    border-radius: 1px;
    margin-top: 15px;
    -webkit-transition: 0.2s all;
    transition: 0.2s all;
  }
}
</style>
